import request from '@/request';
import { getConfig, getDeployDomain, getDebugDomain, getDebugEnabled } from '@/config';
import { getCookie } from '@/utils';

export function loadDeployment(id, { onSuccess }) {
	const refresh = getConfig(config => config.refresh);
	const debug = getDebugEnabled(id);
	const forceRefresh = debug || refresh;

	const url = `https://${getDeployDomain()}/config/${id}${forceRefresh ? '?' + Date.now() : ''}`;
	request({
		url,
		cachePath: id,
		useCache: !debug && !forceRefresh,
		shouldCache: data => !debug && data?.code === 200,
		onSuccess,
	});
}

export function validateAssistant(id, { onSuccess, token }) {
	request({
		url: `https://${getDebugDomain()}/assistant/${id}?token=${token}`,
		shouldCache: () => false,
		onSuccess,
	});
}

export function loadDraft(id, { onSuccess }) {
	request({
		url: `https://${getDebugDomain()}/assistant/draft/${id}?token=${getCookie('MOP_assistant')}&${Date.now()}`,
		shouldCache: () => false,
		onSuccess,
	});
}
